export default "__VITE_ASSET__427f5552__"